import { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import debounce from 'transmute/debounce';
import { useSignUrlForFormMutation } from '../../__generated__/chirp/com/hubspot/url/signer/rpc/UrlSignerRpc.hooks';
import { getPreviewFormUrl } from '../api/PreviewDomainAPI';
const useSignedPreviewUrl = ({
  previewDomain,
  previewRequestData,
  isUngatedForInvoicePreview = false,
  skip = false
}) => {
  const [urlError, setUrlError] = useState();
  const [signedUrlData, setSignedUrlData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const previewUrl = useMemo(() => {
    return previewDomain ? getPreviewFormUrl(previewDomain, isUngatedForInvoicePreview) : '';
  }, [previewDomain, isUngatedForInvoicePreview]);
  const shouldSkipSigning = skip || !previewDomain || !isUngatedForInvoicePreview;
  const [signUrl] = useSignUrlForFormMutation();
  const requestSignedUrl = useCallback(async (previewUrlArg, previewRequestDataArg) => {
    try {
      var _response$data;
      setIsLoading(true);
      setUrlError(undefined);
      const response = await signUrl({
        variables: {
          unsignedUrl: previewUrlArg,
          formData: {
            previewInvoiceRequest: [JSON.stringify(previewRequestDataArg)]
          },
          httpMethod: 'POST'
        }
      });
      setSignedUrlData((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.result);
      setIsLoading(false);
    } catch (error) {
      setUrlError(error instanceof Error ? error : new Error('URL signing failed'));
      setIsLoading(false);
    }
  }, [signUrl]);
  const debouncedRequestSignedUrl = useRef(debounce(100, requestSignedUrl));
  useEffect(() => {
    if (!shouldSkipSigning && previewUrl && previewRequestData && !signedUrlData && !isLoading) {
      void debouncedRequestSignedUrl.current(previewUrl, previewRequestData);
    }
  }, [shouldSkipSigning, previewUrl, previewRequestData, signedUrlData, isLoading]);
  const canSubmitSignedForm = useMemo(() => !shouldSkipSigning && Boolean(signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.signedUrl) && !isLoading, [shouldSkipSigning, signedUrlData, isLoading]);
  return {
    signedUrl: signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.signedUrl,
    loading: isLoading,
    error: urlError,
    canSubmitSignedForm
  };
};
export default useSignedPreviewUrl;